import React, { useState } from 'react';
import { Add, Delete, Edit } from '@mui/icons-material';
import CreateDashboardCardModal from './CreateDashboardCardModal';
import { useDashboardCards } from './useDashboardCards';

const DashboardCardList = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [editingCard, setEditingCard] = useState(null);
    const { cards, isLoading, createCard, updateCard, deleteCard } = useDashboardCards();

    const handleCreateClick = () => {
        setEditingCard(null);
        setModalOpen(true);
    };

    const handleEditClick = (card) => {
        setEditingCard(card);
        setModalOpen(true);
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setEditingCard(null);
    };

    const handleSubmit = async (data) => {
        if (data._id) {
            const result = await updateCard(data);
            if (result?.success) handleModalClose();
        } else {
            const result = await createCard(data);
            if (result?.success) handleModalClose();
        }
    };

    const handleDelete = (card) => {
        if (window.confirm(`Delete "${card.title}"?`)) {
            deleteCard(card._id);
        }
    };

    return (
        <div className="modules-container">
            <div className="modules-header">
                <div>
                    <h1 className="modules-title">Dashboard Cards</h1>
                    <p className="modules-subtitle">Manage dashboard cards</p>
                </div>
                <button
                    type="button"
                    onClick={handleCreateClick}
                    className="modules-create-btn df aic jcc cp"
                >
                    <Add style={{ fontSize: '18px', marginRight: '8px' }} />
                    Create Dashboard Card
                </button>
            </div>

            <div className="modules-table-card">
                <div className="modules-table-header-row df jcsb aic mb1rem">
                    <h3 className="modules-table-title">Cards ({cards.length})</h3>
                </div>

                {isLoading ? (
                    <div className="df jcc aic p4rem">
                        <div className="loader" />
                        <span className="ml1rem fs0-75rem c15">Loading dashboard cards...</span>
                    </div>
                ) : cards.length > 0 ? (
                    <div className="modules-table-wrapper">
                        <table className="w100 fs0-75rem c15" style={{ borderCollapse: 'collapse' }}>
                            <thead>
                                <tr className="fs0-75rem c15" style={{ borderBottom: '2px solid #e0e0e0', background: '#fafafa' }}>
                                    <th className='fs1rem' style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600 }}>Position</th>
                                    <th className='fs1rem' style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600 }}>Title</th>
                                    <th className='fs1rem' style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600 }}>Sub Title</th>
                                    <th className='fs1rem' style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600 }}>Grid</th>
                                    <th className='fs1rem' style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600 }}>Subscription</th>
                                    <th className='fs1rem' style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600 }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cards.map((card) => (
                                    <tr key={card._id} className="fs0-75rem c15" style={{ borderBottom: '1px solid #eee' }}>
                                        <td className='tal' style={{ padding: '12px 16px' }}>{Number.isFinite(Number(card.position)) ? Number(card.position) : 0}</td>
                                        <td className='tal' style={{ padding: '12px 16px' }}>{card.title || '—'}</td>
                                        <td className='tal' style={{ padding: '12px 16px' }}>{card.subTitle || '—'}</td>
                                        <td className='tal' style={{ padding: '12px 16px' }}>{card.grid || 'Grid'}</td>
                                        <td className='tal' style={{ padding: '12px 16px' }}>{card.subscription || 'Free'}</td>
                                        <td className='df jcfs aic' style={{ padding: '12px 16px', textAlign: 'right' }}>
                                            <button
                                                type="button"
                                                onClick={() => handleEditClick(card)}
                                                className="df aic jcc cp bg44 c12"
                                                style={{ padding: 6, marginRight: 8 }}
                                                title="Edit"
                                            >
                                                <Edit style={{ fontSize: 20 }} />
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => handleDelete(card)}
                                                className="df aic jcc cp bg44 c12"
                                                style={{ padding: 6 }}
                                                title="Delete"
                                            >
                                                <Delete style={{ fontSize: 20 }} />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="df fdc aic jcc p4rem">
                        <p className="fs0-75rem c15 fw500 mb1rem">No dashboard cards yet</p>
                        <button
                            type="button"
                            onClick={handleCreateClick}
                            className="modules-create-btn df aic jcc cp"
                        >
                            <Add style={{ fontSize: '18px', marginRight: '8px' }} />
                            Create Dashboard Card
                        </button>
                    </div>
                )}
            </div>

            <CreateDashboardCardModal
                open={modalOpen}
                onClose={handleModalClose}
                onSubmit={handleSubmit}
                card={editingCard}
            />
        </div>
    );
};

export default DashboardCardList;
